export default __webpack_public_path__ + "static/media/flagYellow.04e70144.svg";